'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var bounceOutUp = {
  '20%': {
    transform: (0, _utils.translate3d)(0, '-10px', 0)
  },
  '40%': {
    opacity: 1,
    transform: (0, _utils.translate3d)(0, '20px', 0)
  },
  '45%': {
    opacity: 1,
    transform: (0, _utils.translate3d)(0, '20px', 0)
  },
  to: {
    opacity: 0,
    transform: (0, _utils.translate3d)(0, '-2000px', 0)
  }
};
exports.default = bounceOutUp;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/bounce-out-up.js
// module id = 206
// module chunks = 54990529738226 257444579329143